import { render } from "./CardIeducar.vue?vue&type=template&id=7fa1a40f"
import script from "./CardIeducar.vue?vue&type=script&lang=js"
export * from "./CardIeducar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__